// extracted by mini-css-extract-plugin
module.exports = {"app":"DefaultLayout_app__2zkAf","top":"DefaultLayout_top__2buiB","body":"DefaultLayout_body__3MMUI","bottom":"DefaultLayout_bottom__1veCH"};